import React from 'react';
import PricingCalculator from './PricingCalculator';

function App() {
  return (
    <div>
      <PricingCalculator />
    </div>
  );
}

export default App;
